module.exports = "/_next/static/images/bg-result-fail-8dc36db9.png";